module.exports = __webpack_public_path__ + "img/care-instructions.58ca150d.png";